import { Box, Text } from '@chakra-ui/react';

type CardHoverWrapperProps = {
	children: React.ReactNode;
	title:    string;
	onClick?: () => void;
};

const CardHoverWrapper = ({ onClick, title, children }: CardHoverWrapperProps) => {
	return (
		<Box
			_hover={{
				transform:  'scale(1.05)',
				transition: 'transform 0.3s',
			}}
			borderRadius={'lg'}
			cursor={'pointer'}
			h={'100%'}
			overflow={'hidden'}
			position={'relative'}
			w={'100%'}
			onClick={onClick}
		>
			{children}
			<Box
				_hover={{ opacity: 1 }}
				alignItems={'center'}
				bg={'blackAlpha.500'}
				borderRadius={'lg'}
				display={'flex'}
				inset={'0'}
				justifyContent={'center'}
				opacity={'0'}
				position={'absolute'}
				transition={'opacity 0.3s'}
			>
				<Text
					color={'gray.50'}
					px={'4'}
					textAlign={'center'}
					textStyle={'s6'}
				>
					{title}
				</Text>
			</Box>
		</Box>
	);
};

export default CardHoverWrapper;